<ng-container *ngIf="isLoading; else viewPeople">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>
<ng-template #viewPeople>
  <ng-container *ngIf="modules.length > 0; else noJurors">
    <ng-container *ngFor="let module of modules;">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="module-title-wrapper">
        <h3 class="font-lg font-bold spacing margin-0">{{ module.sub_heading | uppercase }} </h3>
        <mat-divider class="width-100 border-top-width-3"></mat-divider>
      </div>

      <ng-container *ngFor="let people of module.people; index as i">
        <div class="container width-100" fxLayout="row" fxLayoutGap="16px" fxHide.xs fxShow.gt-xs>
          <div fxLayout="column" fxLayoutAlign="start start">
            <uni-user-avatar [user]="people.user" avatarClass="people-profile-image"></uni-user-avatar>
          </div>

          <div fxLayout="column" fxLayoutAlign="start start">
            <a [href]="getProfileUrl(people.user)" target="_blank" class="no-decor">
              <h4 class="font-md font-bold margin-0 cursor-pointer">
                {{ people.user.first_name | titlecase }} {{ people.user.last_name | titlecase }}
              </h4>
            </a>
            <p class="font-sm margin-top-2 margin-bottom-2 font-bold sparro-grey-800">{{ people.bio }}</p>
            <ng-container *ngIf="people.has_short_desc; else truncatedDesc">
              <div>
                <p class="font-sm margin-0 sparro-grey-800 text-justify user-desc">{{ people.desc }}</p>
              </div>
            </ng-container>
            <ng-template #truncatedDesc>
              <ng-container *ngIf="!people.show; else fullLengthDesc">
                <div>
                  <p class="font-sm margin-0 user-desc"> {{people.desc}}</p>
                  <span class="read-more font-bold font-sm sparro-grey-900" (click)="showDesc(i)">Read more</span>
                </div>
              </ng-container>
              <ng-template #fullLengthDesc>
                <div>
                  <p class="font-sm margin-0 sparro-grey-800 text-justify">{{ people.desc }}</p>
                  <p class="read-more font-bold font-sm sparro-grey-900" (click)="showDesc(i)">Show less</p>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>

        <div class="container width-100" fxLayout="column" fxHide.gt-xs fxShow.xs>
          <div fxLayout="row" class="width-100" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutAlign="start start">
              <uni-user-avatar [user]="people.user" avatarClass="people-profile-image"></uni-user-avatar>
            </div>
            <div fxLayout="column" fxLayoutAlign="center start">
              <a [href]="getProfileUrl(people.user)" target="_blank" class="no-decor">
                <h4 class="font-md font-bold margin-0 sparro-grey-900 cursor-pointer">
                  {{ people.user.first_name | titlecase }} {{ people.user.last_name | titlecase }}
                </h4>
              </a>
              <p class="font-sm margin-top-2 font-bold sparro-grey-800 margin-bottom-0">{{ people.bio }}</p>
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="start start">
            <ng-container *ngIf="people.has_short_desc; else truncatedDesc">
              <div>
                <p class="font-sm sparro-grey-800 margin-0 text-justify user-desc">{{ people.desc }}</p>
              </div>
            </ng-container>
            <ng-template #truncatedDesc>
              <ng-container *ngIf="!people.show; else fullLengthDesc">
                <div>
                  <p class="font-sm sparro-grey-800 margin-0 user-desc">{{ people.desc }}</p>
                  <span class="read-more font-bold font-sm sparro-grey-900" (click)="showDesc(i)">Read more</span>
                </div>
              </ng-container>
              <ng-template #fullLengthDesc>
                <div>
                  <p class="font-sm margin-0 text-justify">{{ people.desc }}</p>
                  <p class="read-more font-bold font-sm sparro-grey-900" (click)="showDesc(i)">Show less</p>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #noJurors>
    <div class="width-100 desc">
      <p>Jurors for this competition haven't been announced yet.</p>
    </div>
  </ng-template>
</ng-template>
